// extracted by mini-css-extract-plugin
export default {"container":"Fv-z","brandName":"Gv-z","productName":"Hv-z","productNamePdpEnhancements":"Iv-z","breakLongProductName":"Jv-z"};